module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel-item",
    style: ({
      background: _vm.background,
      height: _vm.height
    })
  }, [(_vm.img) ? _c('img', {
    staticClass: "d-block img-fluid",
    attrs: {
      "src": _vm.img,
      "alt": _vm.imgAlt
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.contentClasses
  }, [(_vm.caption) ? _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.caption)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.text) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ed1b823"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/carousel-slide.vue
// module id = 245
// module chunks = 0